import { computed, Directive, effect, ElementRef, inject, input, Renderer2 } from '@angular/core';
import { getAllClasses, LOADING_COLOR_CLASSES } from '@ral/utils:core/ui';

import { AuiItemBaseComponent } from './item';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[auiLoading]',
    standalone: true,
    host: {
        "[class.before:content-['']]": 'auiLoading()',
        '[class.before:absolute]': 'auiLoading()',
        '[class.before:top-0]': 'auiLoading()',
        '[class.before:-left-0]': 'auiLoading()',
        '[class.before:-bottom-0]': 'auiLoading()',
        '[class.before:from-transparent]': 'auiLoading()',
        '[class.before:to-transparent]': 'auiLoading()',
        '[class.before:via-50%]': 'auiLoading()',
        '[class.before:z-10]': 'auiLoading()',
        '[class.before:bg-gradient-to-r]': 'auiLoading()',
        '[class.before:animate-leftRight]': 'auiLoading()',
        '[class.!opacity-70]': 'auiLoading()',
        '[class.!cursor-wait]': 'auiLoading()',
        '[class.before:via-surface-background-darker]': 'transparent()',
    },
})
export class AuiLoadingDirective {
    private renderer = inject(Renderer2);
    private elementRef = inject(ElementRef<HTMLElement>);
    baseComponent = inject(AuiItemBaseComponent, { self: true });
    auiLoading = input<boolean>(false);
    transparent = computed(() => this.baseComponent.computedColor() === 'transparent' && this.auiLoading());
    gray = computed(() => this.baseComponent.computedColor() === 'gray' && this.auiLoading());
    primary = computed(() => this.baseComponent.computedColor() === 'primary' && this.auiLoading());
    success = computed(() => this.baseComponent.computedColor() === 'success' && this.auiLoading());
    danger = computed(() => this.baseComponent.computedColor() === 'danger' && this.auiLoading());
    warning = computed(() => this.baseComponent.computedColor() === 'warning' && this.auiLoading());
    info = computed(() => this.baseComponent.computedColor() === 'info' && this.auiLoading());
    help = computed(() => this.baseComponent.computedColor() === 'help' && this.auiLoading());

    private bracketClasses = effect(() => {
        const element = this.elementRef.nativeElement;
        const loading = this.auiLoading();
        const color = this.baseComponent.computedColor();

        // Remove all bracket classes first
        getAllClasses(LOADING_COLOR_CLASSES).forEach((cls) => {
            this.renderer.removeClass(element, cls);
        });

        // Add classes if loading
        if (loading) {
            LOADING_COLOR_CLASSES[color].forEach((cls) => {
                this.renderer.addClass(element, cls);
            });
        }
    });
}
